/* global turf */
import { getUUID } from '../helpers/commonHelper';
import { slug } from '../helpers/commonHelper';
import { getRichLine } from '../helpers/elevationChartHelper';
import { defaultGeoFeatureProperties } from '../constants/constants';

export const parseLineFeatureMetadata = (feature) => {
    const { properties } = feature;
    const { published, trailUUID } = properties;
    if (trailUUID || published) {
        return {
            ...properties,
        };
    } else {
        const { name, desc, cmt, surfaceCollection } = properties;
        const newId = getUUID();
        const newName = name || '';
        const newDesc = desc || cmt || name || '';
        return {
            ...defaultGeoFeatureProperties.LineString,
            id: newId,
            trailUUID: newId,
            trailSlug: slug(newName),
            trailName: newName,
            trailDesc: newDesc,
            trailNameEn: newName,
            trailDescEn: newDesc,
            center: turf.centerOfMass(feature).geometry.coordinates,
            surfaceCollection:
                surfaceCollection && surfaceCollection.length > 1
                    ? surfaceCollection
                    : defaultGeoFeatureProperties.LineString.surfaceCollection,
        };
    }
};

export const enrichLine = (line) => {
    let {
        elevMax,
        elevMin,
        elevGain,
        elevLoss,
        surfaceCollection,
    } = line.properties;
    elevGain = 0;
    elevLoss = 0;
    line.geometry.coordinates.forEach((coordinate, idx) => {
        const previousElevation =
            idx > 0 ? line.geometry.coordinates[idx - 1][2] : 0;
        const elevation = coordinate[2];
        if (elevation > elevMax) {
            elevMax = parseInt(elevation, 10);
        }
        if (elevation < elevMin) {
            elevMin = parseInt(elevation, 10);
        }
        if (idx > 0) {
            if (elevation > previousElevation) {
                elevGain += Math.abs(elevation - previousElevation);
            } else {
                elevLoss += Math.abs(elevation - previousElevation);
            }
        }
    });
    const distance = parseFloat(
        turf.length(line, { units: 'kilometers' }).toFixed(2),
    );
    // console.log(line);
    // console.log(turf.length(line, { units: 'kilometers' }));
    // console.log(turf.length(line));
    // const newLine = {
    //     ...line,
    //     geometry: {
    //         ...line.geometry,
    //         coordinates: line.geometry.coordinates.map((c) => [c[0], c[1]]),
    //     },
    // };
    // console.log(newLine);
    // console.log(turf.length(newLine, { units: 'kilometers' }));
    // console.log(turf.length(newLine));
    const bounds = turf.bbox(line);
    const center = turf.centerOfMass(line).geometry.coordinates;
    const requiredTechnique = calculateTechniqueLevelID(
        surfaceCollection,
        elevGain,
    );
    const requiredFitness = calculateFitnessLevelID(distance, elevGain);
    const trailTypeID = calculateTrailTypeID(
        requiredTechnique,
        requiredFitness,
    );
    return {
        ...line,
        properties: {
            ...line.properties,
            elevMax,
            elevMin,
            elevGain,
            elevLoss,
            distance,
            bounds,
            center,
            requiredTechnique,
            requiredFitness,
            trailTypeID,
            richLine: getRichLine(line),
        },
    };
};

const calculateTrailTypeID = (t, f) => {
    if (t === 1 && f === 4) {
        return 4;
    }
    if (t >= 3 && f >= 2) {
        return 3;
    }
    if (t >= 2 && f >= 1) {
        return 2;
    }
    if (t >= 1 && f >= 0) {
        return 1;
    }
    return 0;
};

const calculateFitnessLevelID = (distance, elevation) => {
    const idx = parseInt(elevation + distance * 10, 10);
    if (idx < 750) {
        return 1;
    } else if (idx < 1700) {
        return 2;
    } else if (idx < 3000) {
        return 3;
    }
    return 4;
};

const calculateTechniqueLevelID = (surfaceCollection, totaldistance) => {
    const temp = surfaceCollection
        .map((s) => {
            return [s.key, s.value];
        })
        .map((s, idx) => {
            if (idx < surfaceCollection.length - 1) {
                return {
                    type: s[1],
                    start: s[0],
                    end: surfaceCollection[idx + 1][0],
                    distance: surfaceCollection[idx + 1][0] - s[0],
                    percent:
                        ((surfaceCollection[idx + 1][0] - s[0]) /
                            totaldistance) *
                        100,
                };
            }
            return {
                type: s[1],
                start: s[0],
                end: totaldistance,
                distance: totaldistance - s[0],
                percent: ((totaldistance - s[0]) / totaldistance) * 100,
            };
        });
    let surface = {};
    ['A', 'M', 'S', 'N'].forEach((t) => {
        surface[t] = {
            distance: 0,
            percent: 0,
        };
        const segment = temp.filter((s) => {
            return s.type === t;
        });
        segment.forEach((s) => {
            surface[t].distance += s.total;
            surface[t].percent += s.percent;
        });
    });
    // 4
    if (
        surface.N.percent > 5 ||
        surface.S.percent > 20 ||
        surface.M.percent > 80 ||
        surface.N.distance > 2 ||
        surface.S.distance > 10
    ) {
        return 4;
    }
    // 3
    if (
        surface.N.percent > 1 ||
        surface.S.percent > 5 ||
        surface.M.percent > 50 ||
        surface.S.distance > 2 ||
        surface.M.distance > 20
    ) {
        return 3;
    }
    // 2
    if (
        surface.S.percent > 1 ||
        surface.M.percent > 20 ||
        surface.S.distance > 1
    ) {
        return 2;
    }
    return 1;
};
